export const HANDLE_MODAL_STATE = "HANDLE_MODAL_STATE";

export const handleModalState = showModal => (dispatch, getState) => {
  dispatch({
    type: HANDLE_MODAL_STATE,
    payload: showModal === false ? false : true
  });
};
